import {useCallback, useState, useMemo} from 'react';
import Modal, {useModal} from '@stencil/hotels-modal-component';

import Button from '../../../../../core-components/Button/Button';
import * as S from './WhatOurGuestSays.styles';

const styleMap = {
  POSITIVE: 'greenWrap',
  NEUTRAL: 'yellowWrap',
  NEGATIVE: 'redWrap',
};

const getStyleForTag = (sentiment = '') => styleMap[sentiment] || 'yellowWrap';

const TagItem = ({item, isSelected, onClick}) => (
  <li
    key={item.subConcept}
    className={`${getStyleForTag(item.sentiment)} ${isSelected ? 'active' : ''}`}
    onClick={() => onClick(item, isSelected)}
  >
    <S.OptionsKindWrapSpan>
      {item.displayText} ({item.relatedReviewCount})
    </S.OptionsKindWrapSpan>
  </li>
);

const WhatOurGuestSays = ({tagData = [], onSelectTags = ([]) => {}, selectedTags = []}) => {
  const {isModalOpen, closeModal, openModal} = useModal();

  const shownTags = useMemo(() => tagData.slice(0, 6), [tagData]);
  const hiddenTags = useMemo(() => tagData.slice(6), [tagData]);

  const [tempSelectedTags, setTempSelectedTags] = useState(selectedTags);

  const updateTags = useCallback((tag, isSelected, setTags) => {
    if (isSelected) {
      setTags(prevTags => prevTags.filter(item => item !== tag.subConcept));
    } else {
      setTags(prevTags => [...prevTags, tag.subConcept]);
    }
  }, []);

  const showFinalReviews = useCallback(() => {
    onSelectTags(tempSelectedTags);
    closeModal();
  }, [tempSelectedTags, onSelectTags, closeModal]);

  const handleDirectTagClick = useCallback(
    (tag, isSelected) => {
      updateTags(tag, isSelected, onSelectTags);
    },
    [onSelectTags, updateTags],
  );

  const handleTagClick = useCallback(
    (tag, isSelected) => {
      updateTags(tag, isSelected, setTempSelectedTags);
    },
    [updateTags],
  );

  const handleShowMoreClick = useCallback(() => {
    setTempSelectedTags(selectedTags);
    openModal();
  }, [openModal, selectedTags]);

  return (
    <S.WrapperDiv>
      <S.ContentWrapperDiv>
        <S.HeadingWrapper>
          <S.HeadingTextStyle>What our guests say?</S.HeadingTextStyle>
        </S.HeadingWrapper>
      </S.ContentWrapperDiv>
      <S.MainContentWrapperDiv>
        <S.OptionsWrapperDiv>
          {shownTags.map(item => (
            <TagItem
              key={item.subConcept}
              item={item}
              isSelected={selectedTags.includes(item.subConcept)}
              onClick={handleDirectTagClick}
            />
          ))}
          {hiddenTags.length > 0 && (
            <li
              className="greenWrap"
              onClick={handleShowMoreClick}
              data-testid="d-WhatToKnow-showMore"
            >
              <S.OptionsKindWrapSpan>{`+ ${hiddenTags.length} more`}</S.OptionsKindWrapSpan>
            </li>
          )}
        </S.OptionsWrapperDiv>

        <Modal
          isOpen={isModalOpen}
          closeModal={closeModal}
          modalStyles={{height: 'auto', width: 'auto'}}
          CloseButton={() => null}
        >
          <S.TripPopWrapperDiv>
            <S.TripAdvisorContentWrapperDiv>
              <S.TripAdvisorHeaderDiv>
                <S.HeaderTxtDiv>What our guests say?</S.HeaderTxtDiv>
              </S.TripAdvisorHeaderDiv>
              <S.TripAdvisorPopMainContentDiv>
                <S.OptionsWrapperDiv>
                  {tagData.map(item => (
                    <TagItem
                      key={item.subConcept}
                      item={item}
                      isSelected={tempSelectedTags.includes(item.subConcept)}
                      onClick={handleTagClick}
                    />
                  ))}
                </S.OptionsWrapperDiv>
              </S.TripAdvisorPopMainContentDiv>
              <S.LastContentDiv>
                <Button onClick={showFinalReviews} data-testid="d-WhatToKnow-showreviews">
                  <S.ShowReviewSpan>SHOW REVIEWS</S.ShowReviewSpan>
                </Button>
              </S.LastContentDiv>
            </S.TripAdvisorContentWrapperDiv>
          </S.TripPopWrapperDiv>
        </Modal>
      </S.MainContentWrapperDiv>
    </S.WrapperDiv>
  );
};

export default WhatOurGuestSays;
